import { useParams } from "react-router-dom";
import SEO from "../components/SEO";
import { useEffect, useState } from "react";
import axios from "axios";
import { format } from "date-fns";
import BlogRenderer from "../blog/BlogRenderer";
import BlogImage from "../blog/BlogImage";

function BlogDetails() {
  const REACT_STRAPI_API = process.env.REACT_APP_STRAPI_API;
  const { id } = useParams(); // 👉 "r8uhrcym7j73s9sqi0mrhvtb"
  const [blog, setBlog] = useState({});

  useEffect(() => {
    getBlogs();
  }, [id]);

  async function getBlogs() {
    const url = `${REACT_STRAPI_API}/blogs/${id}?populate=*`;
    console.log(url, "????????");

    try {
      const response = await axios.get(url);
      console.log("Data fetched successfully:", response.data);
      console.log("Data fetched successfully:", response.data?.data);

      setBlog(response.data?.data);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        // Handle Axios-specific errors (e.g., network errors, HTTP status codes)
        console.error("Axios error:", error.message);
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.error("Response data:", error.response.data);
          console.error("Response status:", error.response.status);
          console.error("Response headers:", error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          console.error("No response received:", error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error("Error in request setup:", error.message);
        }
      } else {
        // Handle other types of errors
        console.error("Generic error:", error);
      }
    }
  }

  if (!blog) return <p>Blog not found.</p>;

  const {
    title,
    content,
    bannerImage,
    authorName,
    category,
    readTime,
    publishAt,
  } = blog;

  return (
    <div className="max-w-4xl p-6 mx-auto">
      {/* Banner */}
      <BlogImage image={bannerImage} />

      {/* Title */}
      <BlogRenderer blocks={title} />

      <div className="mb-6 text-sm text-gray-500">
        <span>{category}</span> • <span>{readTime} min read</span> •{" "}
        <span>{new Date(publishAt).toDateString()}</span>
      </div>

      {/* Content */}
      <BlogRenderer blocks={content} />

      {/* Author */}
      <div className="flex gap-1 pt-4 mt-10 text-gray-700 border-t">
        <p className="my-3 font-medium text-gray-300">By:</p>
        <BlogRenderer blocks={authorName} />
      </div>
    </div>
  );
}

export default BlogDetails;
